/**
 * Activity log panel — appends timestamped, color-coded messages to the UI.
 *
 * Usage:
 *   import { log } from './logger.js';
 *   log('Something happened', 'success');
 */

let logElement = null;

/**
 * Bind the logger to a DOM element.
 * @param {HTMLElement} el — The container element (e.g. <div class="log-area">)
 */
export function initLogger(el) {
  logElement = el;
}

/**
 * Append a log message.
 * @param {string} msg  — The message text (HTML-safe plain text recommended).
 * @param {'info'|'success'|'error'|'warn'} [type='info']
 */
export function log(msg, type = 'info') {
  if (!logElement) {
    console.log(`[${type}]`, msg);
    return;
  }
  const ts = new Date().toLocaleTimeString();
  const div = document.createElement('div');
  div.className = `log-${type}`;
  div.textContent = `[${ts}] ${msg}`;
  logElement.appendChild(div);
  logElement.scrollTop = logElement.scrollHeight;
}
